import FormDialog from '../form/form-dialog';
import FormInput from '../form/form-input';
import http from '../utils/http';
import useForm from '../hooks/useForm';


import { isEmpty } from 'lodash';
import React from 'react';

const EnvironmentAddModal = (props) => {
    const {
        state,
        onChange,
        onChangeBulk,
        onInvalidForm,
        onResetFormErrors
    } = useForm({
        initialState: {
            environmentAddName: '',
        }
    });
    const {
        config,
        isOpen,
        onChangeBulk: parentOnChangeBulk,
        applicationId
    } = props;
    return (
        <FormDialog
            dialogTitle={'Add New Environment'}
            dialogSubHeading={'Add a new environment with the following details'}
            handleClose={() => {
                onResetFormErrors();
                onChangeBulk({
                    environmentAddName: ''
                })
                parentOnChangeBulk({ environmentAddModalIsOpen: false })
            }}
            handleSubmit={async () => {
                const errors = {};
                if (!state.values.environmentAddName) errors.environmentAddName = 'You must supply an environment name';
                if (!isEmpty(errors)) return onInvalidForm(errors);

                await http.post({
                    name: state.values.environmentAddName,
                    applicationId
                }, `${config.uri.base}/environment`);

                const environments = await http.get({
                    applicationId
                }, `${config.uri.base}/environment`);

                onChangeBulk({
                    environmentAddName: ''
                });

                parentOnChangeBulk({
                    environmentAddModalIsOpen: false,
                    environments: environments.rows,
                });
            }}
            isOpen={isOpen}
        >
            <FormInput
                path='environmentAddName'
                value={state.values.environmentAddName}
                error={state.errors.environmentAddName}
                onChange={onChange}
            />
        </FormDialog>
    );
}

export default EnvironmentAddModal;
